<template>
    <div>
        <el-table :data="list">
            <el-table-column label="类型">
                <template slot-scope="scope">
                    {{scope.row.taskType === 0 ? '投入空投' : '未知'}}
                </template>
            </el-table-column>
            <el-table-column prop="description" label="描述">
            </el-table-column>
            <el-table-column prop="status" label="状态">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.__status.color">
                        {{scope.row.__status.text}}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column label="是否发送短信">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.sendMsg" active-color="#13ce66" inactive-color="#ff4949" disabled/>
                </template>
            </el-table-column>
            <el-table-column label="创建时间">
                <template slot-scope="scope">
                    <span>{{scope.row.createTime | moment}}</span>
                </template>
            </el-table-column>
            <el-table-column label="更新时间">
                <template slot-scope="scope">
                    <span>{{scope.row.updateTime | moment}}</span>
                </template>
            </el-table-column>

            <el-table-column label="操作" width="200">
                <template slot-scope="scope">
                    <el-button type="primary" size="small" @click="viewDetail(scope.row)">查看</el-button>
                    <el-button type="danger" size="small" @click="executeAirDrop(scope.row.id)">执行空投</el-button>
                </template>
            </el-table-column>
        </el-table>
        <pagination :size="pagination.size" :page="pagination.page" :total="totalCount"
                    @pageChanged="handleCurrentChange"/>
        <detail @refresh="handleCurrentChange({ page: 1 })"/>

    </div>
</template>

<script>
    import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';
    import api from '../../api';
    import Pagination from 'components/pagination';
    import Detail from '../detail';

    export default {
        name: 'airdropList',
        computed: {
            ...mapState('incubatorAirDrop', ['totalCount', 'pagination']),
            ...mapGetters('incubatorAirDrop', ['list'])
        },
        components: {
            Pagination,
            Detail
        },
        methods: {
            ...mapActions('incubatorAirDrop', ['remove']),
            ...mapMutations('incubatorAirDrop', ['setDetail']),
            handleCurrentChange(pagination) {
                this.$emit('refresh', pagination);
            },
            viewDetail(item) {
                this.setDetail(item);
            },
            executeAirDrop(id) {
                this.$confirm('确认执行空投任务吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.executeAirDrop({id: id}).then(({data}) => {
                        this.$message.success('执行成功！');
                        this.$emit('refresh', {page: 1});
                    });
                }).catch(() => {
                });
            }
        }
    };
</script>

<style lang="less" scoped>
</style>
